import React from 'react';
import { Pressable, Text, StyleSheet } from 'react-native';
import { NETFLIX_COLORS, NETFLIX_SPACING } from '../theme/netflixTheme';
import { isSignupFirstFlow, isPaymentFirstFlow } from '../config/authFlow';

interface AuthFlowButtonProps {
  onSignupFirst?: () => void;
  onPaymentFirst?: () => void;
}

export function AuthFlowButton({ onSignupFirst, onPaymentFirst }: AuthFlowButtonProps) {
  const handlePress = () => {
    if (isSignupFirstFlow() && onSignupFirst) {
      onSignupFirst();
    } else if (isPaymentFirstFlow() && onPaymentFirst) {
      onPaymentFirst();
    }
  };

  const buttonLabel = isSignupFirstFlow() ? 'Assistir' : 'Entrar';
  const buttonTooltip = isSignupFirstFlow()
    ? 'Cadastre-se para assistir'
    : 'Faça login para continuar';

  return (
    <Pressable
      onPress={handlePress}
      style={styles.button}
      accessibilityLabel={buttonTooltip}
    >
      <Text style={styles.buttonText}>{buttonLabel}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: NETFLIX_COLORS.primary,
    paddingHorizontal: NETFLIX_SPACING.lg,
    paddingVertical: NETFLIX_SPACING.sm,
    borderRadius: 6,
  },
  buttonText: {
    color: NETFLIX_COLORS.white,
    fontSize: 14,
    fontWeight: '600',
  },
});
